import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"


import { enter, leave } from "./main-menu";
import TopMenuLink from "./TopMenuLink.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TopMenuComponent',
  props: {
  menu: Object,
  isRoot: Boolean,
  layout: String,
  position: String,
  menuIndex: Number,
},
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  const _component_TopMenuComponent = _resolveComponent("TopMenuComponent", true)!

  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass([
      {
        'relative [&:hover>ul]:block [&:hover>a>div:nth-child(2)>svg]:-rotate-180':
          __props.isRoot && __props.layout === 'rubick',
        '[&:hover>a>div:nth-child(1)]:before:bg-white/5 [&:hover>a>div:nth-child(1)]:before:dark:bg-darkmode-500/70':
          __props.isRoot && !__props.menu.active && __props.layout === 'rubick',
        'px-5 relative [&:hover>ul]:block [&:hover>a>div:nth-child(2)>svg]:-rotate-90':
          !__props.isRoot && __props.layout === 'rubick',
        'px-5': !__props.isRoot && __props.menu.active && __props.layout === 'rubick',
      },
      {
        'relative [&:hover>ul]:block [&:hover>a>div:nth-child(2)>svg]:rotate-180':
          __props.isRoot && __props.layout === 'enigma',
        '[&:hover>a]:bg-slate-100 [&:hover>a]:dark:bg-transparent':
          __props.isRoot && !__props.menu.active && __props.layout === 'enigma',
        '[&:hover>a]:before:content-[\'\'] [&:hover>a]:before:block [&:hover>a]:before:inset-0 [&:hover>a]:before:rounded-full [&:hover>a]:xl:before:rounded-xl [&:hover>a]:before:absolute [&:hover>a]:before:z-[-1] [&:hover>a]:before:border-b-[3px] [&:hover>a]:before:border-solid [&:hover>a]:before:border-black/[0.08] [&:hover>a]:before:dark:bg-darkmode-700':
          __props.isRoot && !__props.menu.active && __props.layout === 'enigma',
        'px-5 relative [&:hover>ul]:block [&:hover>a>div:nth-child(2)>svg]:-rotate-90':
          !__props.isRoot && __props.layout === 'enigma',
        'px-5': !__props.isRoot && __props.menu.active && __props.layout === 'enigma',
      },
      {
        'relative [&:hover>ul]:block [&:hover>a>div:nth-child(2)>svg]:rotate-180':
          __props.isRoot && __props.layout === 'icewall',
        '[&:hover>a]:bg-primary/60 [&:hover>a]:dark:bg-transparent':
          __props.isRoot && !__props.menu.active && __props.layout === 'icewall',
        '[&:hover>a]:before:content-[\'\'] [&:hover>a]:before:block [&:hover>a]:before:inset-0 [&:hover>a]:before:bg-white/[0.04] [&:hover>a]:xl:before:bg-white/10 [&:hover>a]:before:rounded-full [&:hover>a]:xl:before:rounded-lg [&:hover>a]:before:absolute [&:hover>a]:before:z-[-1] [&:hover>a]:before:dark:bg-darkmode-700':
          __props.isRoot && !__props.menu.active && __props.layout === 'icewall',
        'px-5 relative [&:hover>ul]:block [&:hover>a>div:nth-child(2)>svg]:-rotate-90':
          !__props.isRoot && __props.layout === 'icewall',
        'top-menu--active': __props.isRoot && __props.menu.active && __props.layout === 'icewall',
      },
      {
        'px-5 relative [&:hover>ul]:block [&:hover>a>div:nth-child(2)>svg]:-rotate-90':
          __props.layout === 'tinker',
      },
    ])
  }, [
    _createVNode(TopMenuLink, {
      class: _normalizeClass({
        // Animation
        [`opacity-0 translate-y-[50px] animate-[0.4s_ease-in-out_0.3s_intro-menu] animate-fill-mode-forwards animate-delay-${
          (__props.menuIndex + 1) * 10
        }`]: __props.isRoot,
      }),
      menu: __props.menu,
      layout: __props.layout,
      isRoot: __props.isRoot
    }, null, 8, ["class", "menu", "layout", "isRoot"]),
    (__props.menu.subMenu?.length)
      ? (_openBlock(), _createElementBlock("ul", {
          key: 0,
          class: _normalizeClass([
        {
          'shadow-[0px_3px_20px_#0000000b] dark:shadow-[0px_3px_7px_#0000001c] bg-primary dark:bg-darkmode-600 hidden w-56 absolute rounded-md z-20 px-0 mt-1':
            __props.isRoot && __props.layout === 'rubick',
          'before:content-[\'\'] before:block before:absolute before:w-full before:h-full before:bg-white/[0.04] before:inset-0 before:rounded-md before:z-[-1] dark:before:bg-black/10':
            __props.isRoot && __props.layout === 'rubick',
          'after:content-[\'\'] after:w-full after:h-1 after:absolute after:top-0 after:left-0 after:-mt-1 after:cursor-pointer':
            __props.isRoot && __props.layout === 'rubick',
          'left-[100%] ml-0 shadow-[0px_3px_20px_#0000000b] bg-primary hidden w-56 absolute rounded-md z-20 px-0 top-0 mt-0 before:block before:absolute before:w-full before:h-full before:bg-black/10 before:inset-0 before:rounded-md before:z-[-1] dark:bg-darkmode-600 dark:shadow-[0px_3px_7px_#0000001c]':
            !__props.isRoot && __props.layout === 'rubick',
        },
        {
          'shadow-[0px_3px_20px_#00000014] dark:shadow-[0px_3px_7px_#0000001c] bg-slate-100 dark:bg-darkmode-600 hidden w-56 absolute rounded-md z-20 px-0 mt-1':
            __props.layout === 'enigma',
          'before:content-[\'\'] before:block before:absolute before:w-full before:h-full before:bg-white/[0.04] before:inset-0 before:rounded-md before:z-[-1] dark:before:bg-black/10':
            __props.layout === 'enigma',
          'after:content-[\'\'] after:w-full after:h-1 after:absolute after:top-0 after:left-0 after:-mt-1 after:cursor-pointer':
            __props.layout === 'enigma',
          'left-[100%] top-0': !__props.isRoot && __props.layout === 'enigma',
        },
        {
          'shadow-[0px_3px_20px_#0000000b] bg-primary hidden w-56 absolute rounded-md z-20 px-0 mt-1 dark:bg-darkmode-600 dark:shadow-[0px_3px_7px_#0000001c]':
            __props.isRoot && __props.layout === 'icewall',
          'before:block before:absolute before:w-full before:h-full before:bg-white/[0.04] before:inset-0 before:rounded-md before:z-[-1] dark:before:bg-black/10':
            __props.layout === 'icewall',
          'after:w-full after:h-1 after:absolute after:top-0 after:left-0 after:-mt-1 after:cursor-pointer':
            __props.isRoot && __props.layout === 'icewall',
          'shadow-[0px_3px_20px_#0000000b] left-[100%] bg-primary hidden rounded-md mt-0 ml-0 top-0 w-56 absolute z-20 px-0 dark:bg-darkmode-600 dark:shadow-[0px_3px_7px_#0000001c]':
            !__props.isRoot && __props.layout === 'icewall',
        },
        {
          'shadow-[0px_3px_20px_#0000000b] dark:shadow-[0px_3px_7px_#0000001c] bg-primary dark:bg-darkmode-600 hidden w-56 absolute rounded-md z-20 px-0 mt-1':
            __props.isRoot && __props.layout === 'tinker',
          'before:content-[\'\'] before:block before:absolute before:w-full before:h-full before:bg-white/[0.04] before:inset-0 before:rounded-md before:z-[-1] dark:before:bg-black/10':
            __props.isRoot && __props.layout === 'tinker',
          'after:content-[\'\'] after:w-full after:h-1 after:absolute after:top-0 after:left-0 after:-mt-1 after:cursor-pointer':
            __props.isRoot && __props.layout === 'tinker',
          'shadow-[0px_3px_20px_#0000000b] dark:shadow-[0px_3px_7px_#0000001c] left-[100%] bg-primary dark:bg-darkmode-600 hidden w-56 absolute rounded-md mt-0 ml-0 top-0 z-20 px-0':
            !__props.isRoot && __props.layout === 'tinker',
        },
      ])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.menu.subMenu, (menu, index) => {
            return (_openBlock(), _createBlock(_component_TopMenuComponent, {
              key: index,
              menuIndex: index,
              menu: menu,
              isRoot: false,
              layout: __props.layout
            }, null, 8, ["menuIndex", "menu", "layout"]))
          }), 128))
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
}
}

})